<template>
  <li class="m-filters__item m-filters__item--bold m-filters__item--parent">
    <div class="m-filters__arrow">
      <span class="checkbox-group-parent">
        <slot name="parent" />
      </span>
      <span :class="'arrow ' + (showChildren ? 'arrow__open' : '')" @click="toggleShowChildren" />
    </div>
      
    <ul class="m-filters m-filters--child" v-if="showChildren">
      <li class="m-filters__item m-filters__item--deep-child">
        <span>
          <slot name="children" />
        </span>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  data() {
    return {
      showChildren: false
    }
  },
  methods: {
    toggleShowChildren: function() {
      this.showChildren = !this.showChildren
    }
  }
}
</script>
